import { render, staticRenderFns } from "./Arrange.vue?vue&type=template&id=90ba8a88&scoped=true&"
import script from "./Arrange.vue?vue&type=script&lang=js&"
export * from "./Arrange.vue?vue&type=script&lang=js&"
import style0 from "./Arrange.vue?vue&type=style&index=0&id=90ba8a88&lang=scss&scoped=true&"
import style1 from "./Arrange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba8a88",
  null
  
)

export default component.exports